export const LOADING_SUPPLIER = "LOADING_SUPPLIER";
export const GET_SUPPLIER_LIST = "GET_SUPPLIER_LIST";
export const GET_SUPPLIERBYID = "GET_SUPPLIERBYID";
export const REMOVE_SUPPLIER = "REMOVE_SUPPLIER";
export const ADD_SUPPLIER = "ADD_SUPPLIER";
export const UPDATE_SUPPLIER = "UPDATE_SUPPLIER";